import { render, staticRenderFns } from "./SaveReportWizardTPA.vue?vue&type=template&id=e3c234ca"
import script from "./SaveReportWizardTPA.vue?vue&type=script&lang=js"
export * from "./SaveReportWizardTPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports